const colors = [
  '#094f81',
  '#224067',
  '#3c314d',
  '#523',
  '#5e1d2b',
  '#770e11',
  '#800909',
  '#42c0e6',
  '#48b6e6',
  '#4eace6',
  '#54a2e6',
  '#5b97e6',
  '#618de6',
  '#6783e6',
  '#6d79e6',
  '#736fe6',
  '#7a64e6',
  '#805ae6',
];

export default colors;
